'use strict';

export default (API) => ({
    communications: {
        getMessageConfigurationsByEstablishment: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/configuration/messages';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        insertOrUpdateEstablishmentMessageConfigurations: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/configuration/messages';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        }
    }
});
